export enum senderType {
    Adviser = 0,
    Customer = 1
}